import React, { createContext, useContext, useEffect, useState } from 'react'

const ToastContext = createContext(null)

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([])

  const showToast = (toastOrMessage, fallbackType = 'info') => {
    const toastConfig =
      typeof toastOrMessage === 'string'
        ? { message: toastOrMessage, type: fallbackType }
        : toastOrMessage || {}

    const { type = 'info', message } = toastConfig

    if (
      !message ||
      typeof message !== 'string' ||
      message.trim().length === 0
    ) {
      return
    }

    const id = Date.now() + Math.random()
    setToasts((prev) => [...prev, { id, type, message: message.trim() }])
    setTimeout(() => dismiss(id), 4000)
  }

  const dismiss = (id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id))
  }

  useEffect(() => {
    const handler = (e) => {
      const detail = e.detail || {}
      if (detail && detail.message) showToast(detail)
    }
    window.addEventListener('app-toast', handler)
    return () => window.removeEventListener('app-toast', handler)
  }, [])

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {/* simple inline toast renderer */}
      <div
        style={{
          position: 'fixed',
          top: 16,
          right: 16,
          zIndex: 1000,
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
        }}
      >
        {toasts.map((t) => (
          <div
            key={t.id}
            style={{
              background:
                t.type === 'error'
                  ? '#fee2e2'
                  : t.type === 'success'
                    ? '#dcfce7'
                    : '#e5e7eb',
              color: '#111827',
              border: '1px solid #d1d5db',
              borderRadius: 8,
              padding: '10px 12px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            }}
          >
            {t.message}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  )
}

export const useToast = () => {
  const ctx = useContext(ToastContext)
  if (!ctx) throw new Error('useToast must be used within ToastProvider')
  return ctx
}
